import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import getMoistureContentDerivedFromMeasurementsConfig from 'Components/Worksheets/MoistureContentWorksheet/derivedFromMeasurementsConfig';
import getMoistureContentMeasuredUsingConfig from 'Components/Worksheets/MoistureContentWorksheet/measuredUsingConfig';
import getDerivedFromMeasurementsConfig from 'Components/Worksheets/OrganicContentWorksheet/derivedFromMeasurementsConfig';
import getMeasuredUsingConfig from 'Components/Worksheets/OrganicContentWorksheet/measuredUsingConfig';
import qestIds from '../../../QestIds';
import { getLabelConfig, getMoistureContentLabelConfig } from './labelConfig';

const defaultReadability = { defaultReadability: 0.01, defaultUom: 'g' };

//Moisture Content for ASTM D2974
//nearest 1 % for <100 %;
//nearest 5 % for 100-500 %;
//nearest 10 % for 501-1000 %;
//nearest 20 % for >1000 %
const moistureFormat = (v: number) => {
  if (v < 100) return { nearest: 1 };
  else if (v <= 500) return { nearest: 5 };
  else if (v <= 1000) return { nearest: 10 };
  else if (v > 1000) return { nearest: 20 };
  else return { nearest: 1 };
};

const getConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.Combustion.FurnaceDuration`]: { uom: 'min', format: { nearest: 15 } },
      [`${prefix}.Combustion.FurnaceTemperature`]: { uom: '°C', format: { nearest: 1 } },
      [`${prefix}.Combustion.AshPercent`]: { format: { nearest: 0.1 } },
      [`${prefix}.Combustion.OrganicContentPercent`]: { format: { nearest: 0.1 } },

      [`${prefix}.Results.MoistureContent`]: { format: moistureFormat },
      [`${prefix}.Results.AshContent`]: { format: { nearest: 0.1 } },
      [`${prefix}.Results.OrganicMaterial`]: { format: { nearest: 0.1 } },
    },
    getLabelConfig(prefix),
    getMeasuredUsingConfig(prefix),
    getDerivedFromMeasurementsConfig(prefix),
    {
      [`${prefix}.AirDrying.Balance`]: defaultReadability,
      [`${prefix}.Combustion.Balance`]: defaultReadability,
    },
    getMoistureContentConfig(`${prefix}.OvenDrying`)
  );

/**
 * Organic Content's Oven Drying is stored as a moisture content
 * This config is provided for cases when it can be retrieved individually (e.g. by the Dry Mass Entry grid)
 * In the standalone worksheet, these values are remapped to the Oven Drying model
 */
const getMoistureContentConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.Equipment.DryingTemperature`]: { uom: '°C', format: { nearest: 1 } },
      [`${prefix}.Results.MoistureContentPercent`]: { format: moistureFormat },
      [`${prefix}.DryingTray.DryMassReadings.DryingTime`]: { uom: 'h', format: { nearest: 0.01 } },
    },
    getMoistureContentMeasuredUsingConfig(prefix),
    getMoistureContentDerivedFromMeasurementsConfig(prefix),
    getMoistureContentLabelConfig(prefix),
    {
      [`${prefix}.Equipment.Balance`]: defaultReadability,
      [`${prefix}.Equipment.DryMassBalance`]: defaultReadability,
    }
  );

export default {
  [qestIds.organicContent.ASTM_D2974.rev2020]: getConfig,
  [qestIds.moistureContent.ASTM_D2974.rev2020]: getMoistureContentConfig,
};
